import React, { useState, useEffect, useContext } from 'react'
import { useTranslate, required, TextInput, NumberInput, useNotify, SelectInput, Form } from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import { Dialog, DialogContent, DialogTitle, Skeleton, Grid, Button, DialogActions } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import { documentTypeServices } from 'src/services/reservation/documentType/documentType.service'
import LoadingButton from '@mui/lab/LoadingButton'
import { useCardId } from 'src/components/pages/sales/reservation/context/CardIdContext'

export const ContactModal = ({ open, handleClose, titleModal, onSubmit, loadingButton }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [optionsDocumentType, setOptionsDocumentType] = useState([])
  const [loadingDocumentType, setLoadingDocumentType] = useState(false)
  const { cardId } = useCardId()

  useEffect(() => {
    getDocumentType()
  }, [])

  const getDocumentType = async () => {
    try {
      setLoadingDocumentType(true)
      const allDocumentType = await documentTypeServices.getByAll()
      if (allDocumentType) {
        setOptionsDocumentType(allDocumentType)
        setLoadingDocumentType(false)
        return
      }
      notify(`document type not found`, { type: 'error' })
      setLoadingDocumentType(false)
    } catch (error) {
      notify(`document type not found please, refresh page`, { type: 'error' })
      setLoadingDocumentType(false)
    }
  }

  const postSave = (data) => {
    onSubmit && onSubmit(data, cardId)
  }

  return (
    <Dialog open={open} maxWidth='lg' fullWidth={true}>
      <DialogTitle>{titleModal}</DialogTitle>
      <DialogContent>
        <Form id='post_create_form' warnWhenUnsavedChanges onSubmit={postSave}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='contact.name' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.surname')} required>
              <TextInput source='contact.surname' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.email')}>
              <TextInput source='contact.email' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_number')}>
              <NumberInput source='contact.document_number' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.phone')}>
              <TextInput source='contact.phone_number' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.birth_date')}>
              <DatePickers source={`contact.birthday`} />
            </EditInputsWrap>
            {loadingDocumentType ? (
              <EditInputsWrap label={translate('ra.field.document_type')} md={12}>
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              </EditInputsWrap>
            ) : (
              <EditInputsWrap label={translate('ra.field.document_type')}>
                <SelectInput
                  source='contact.document_type_id'
                  optionText='long_name'
                  optionValue='id'
                  fullWidth
                  choices={optionsDocumentType}
                  label=''
                />
              </EditInputsWrap>
            )}
          </Grid>
        </Form>

        <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
          <LoadingButton
            loading={loadingButton}
            variant='contained'
            startIcon={<SaveIcon />}
            form='post_create_form'
            type='submit'
          >
            {translate('ra.action.save')}
          </LoadingButton>
          <Button onClick={handleClose} variant='outlined' color='error'>
            {translate('ra.action.cancel')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
